import { createSelector } from '@ngrx/store';
import { selectFeatureStore } from './generic.selectors';

export const selectNmcNmbiStatus = createSelector(
  selectFeatureStore,
  ({ nmcNmbiStatus }) => nmcNmbiStatus,
);

export const selectNmcNmbiWasLoaded = createSelector(
  selectNmcNmbiStatus,
  ({ isLoaded }) => isLoaded,
);
